export default __webpack_public_path__ + "static/media/fond-1.12d27fb9.jpg";